import { createEvent } from 'effector';
import { CheckerDataInterface, CheckerFilterRequest, CheckerType } from '../types';

export const onGetChecker = createEvent<CheckerFilterRequest>('onGetChecker');
export const onSetStepChecker = createEvent<CheckerType>('onSetStepChecker');
export const onSetOrderChecker = createEvent<Array<CheckerDataInterface>>('onSetOrderChecker');
export const onSetStepDataChecker = createEvent<CheckerDataInterface>('onSetStepDataChecker');
export const onResetChecker = createEvent<any>('onResetChecker');
